import baseUrl from "./action/base-url";

export default {
  redirect: null,
  routeName: "",
  socket: null,

  upload: {},
  baseUrl,
  userType: "provider", // can be 'provider' or 'observer'
};
